// extracted by mini-css-extract-plugin
export default {"title":"title--6bE9A","price":"price--2QiBg"};